'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _getAnyCompanyLogo = require('conversations-schema/chat-heading-config/operators/getAnyCompanyLogo');

var _UISimpleAvatar = require('ui-addon-avatars/UISimpleAvatar');

var _UISimpleAvatar2 = _interopRequireDefault(_UISimpleAvatar);

var _getChatHeadGroupStyle = require('../util/getChatHeadGroupStyle');

var _RecordPropType = require('conversations-prop-types/prop-types/RecordPropType');

var _RecordPropType2 = _interopRequireDefault(_RecordPropType);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var CustomChatHeading = function (_React$Component) {
  _inherits(CustomChatHeading, _React$Component);

  function CustomChatHeading() {
    _classCallCheck(this, CustomChatHeading);

    return _possibleConstructorReturn(this, (CustomChatHeading.__proto__ || Object.getPrototypeOf(CustomChatHeading)).apply(this, arguments));
  }

  _createClass(CustomChatHeading, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          chatHeadingConfig = _props.chatHeadingConfig,
          mobile = _props.mobile,
          size = _props.size;

      var src = (0, _getAnyCompanyLogo.getAnyCompanyLogo)(chatHeadingConfig);

      if (!chatHeadingConfig || !src) {
        return null;
      }

      return _react2.default.createElement(
        'div',
        { className: 'justify-center', style: (0, _getChatHeadGroupStyle.getChatHeadGroupStyle)({ mobile: mobile }) },
        _react2.default.createElement(_UISimpleAvatar2.default, { src: src, className: 'chat-head-avatar', size: size })
      );
    }
  }]);

  return CustomChatHeading;
}(_react2.default.Component);

CustomChatHeading.propTypes = {
  chatHeadingConfig: _react.PropTypes.oneOfType([(0, _RecordPropType2.default)('CompanyChatHeadingConfig'), (0, _RecordPropType2.default)('OwnerChatHeadingConfig')]),
  mobile: _react.PropTypes.bool,
  size: _react.PropTypes.string.isRequired
};

exports.default = CustomChatHeading;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-components/static-1.4266/js/visitor-widget/CustomChatHeading.js
// module id = 503
// module chunks = 2 3